// extracted by mini-css-extract-plugin
module.exports = {"container":"RepeatingText-module--container--11v-X","text":"RepeatingText-module--text--371Jo"};